import type { HighlightAdapter } from './highlight-adapter.js'
import { selectionService } from './selection-service.js'
import type { SelectableFeatureRef } from './selectable-feature-ref.js'

class HighlightManager {
  private adapters: HighlightAdapter[] = []
  private unsubscribe: (() => void) | undefined

  registerAdapter(adapter: HighlightAdapter): void {
    this.adapters.push(adapter)
  }

  unregisterAdapter(adapter: HighlightAdapter): void {
    this.adapters = this.adapters.filter(a => a !== adapter)
  }

  connect(): void {
    this.unsubscribe = selectionService.onChange(
      (selected: ReadonlyMap<string, SelectableFeatureRef>) => {
        for (const adapter of this.adapters) {
          const relevant = [...selected.values()].filter(ref =>
            adapter.sources.includes(ref.source)
          )
          if (relevant.length > 0) {
            adapter.applyHighlights(relevant)
          } else {
            adapter.clearHighlights()
          }
        }
      }
    )
  }

  disconnect(): void {
    this.unsubscribe?.()
    this.unsubscribe = undefined
    for (const adapter of this.adapters) {
      adapter.clearHighlights()
    }
  }
}

export const highlightManager = new HighlightManager()
